import { toReactive } from "@vueuse/core";
import _ from "lodash";

export default function useFiltersDeprecated(filters: object) {
  const filtersRef = toReactive(filters);

  const updateArray = (key: string, value: string | number | boolean) => {
    value = value.toString();
    let index = -1;

    if (!(key in filtersRef)) {
      filtersRef[key] = [];
    } else {
      index = filtersRef[key].indexOf(value);
    }

    index > -1 ? _.pull(filtersRef[key], value) : filtersRef[key].push(value);
  };

  const reset = (state: object = {}) => {
    Object.keys(filtersRef).forEach((key) => {
      filtersRef[key] = Array.isArray(filtersRef[key]) ? [] : null;
    });

    Object.keys(state).forEach((key) => {
      filtersRef[key] = state[key];
    });
  };

  return {
    updateArray,
    reset,
  };
}
